/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Contact_Reason_Buy_DetailInputs */

const en_marketing_contact_reason_buy_detail = /** @type {(inputs: Marketing_Contact_Reason_Buy_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licensing questions, invoicing, or whether your use fits. Ask before you buy.`)
};

const es_marketing_contact_reason_buy_detail = /** @type {(inputs: Marketing_Contact_Reason_Buy_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dudas sobre la licencia, facturación o si tu caso encaja. Pregunta antes de comprar.`)
};

const fr_marketing_contact_reason_buy_detail = /** @type {(inputs: Marketing_Contact_Reason_Buy_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions de licence, facturation, ou savoir si votre usage entre dans le cadre. Demandez avant d'acheter.`)
};

/**
* | output |
* | --- |
* | "Licensing questions, invoicing, or whether your use fits. Ask before you buy." |
*
* @param {Marketing_Contact_Reason_Buy_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_contact_reason_buy_detail = /** @type {((inputs?: Marketing_Contact_Reason_Buy_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Contact_Reason_Buy_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_contact_reason_buy_detail(inputs)
	if (locale === "es") return es_marketing_contact_reason_buy_detail(inputs)
	return fr_marketing_contact_reason_buy_detail(inputs)
});